@if (hostedCustomPages && activePageName) {
  <div
    class="custom-page-navigator-container"
    >
    <div class="navigation-accordion-container" [ngClass]="showSidebar ? 'show' : 'hide'">
      @if (mobile) {
        <div class="mobile-header">
          <h2>Bite Site</h2>
          <div class="collapse-button" (click)="showSidebar = !showSidebar">
            <i _ngcontent-xqp-c464="" class="fas fa-chevron-up" aria-hidden="true"></i>
          </div>
        </div>
      }
      <div class="navigation-accordion-inner-container">
        @if (!mobile) {
          <h2 class="navigator-header">Bite Site</h2>
        }
        <mat-accordion>
          @if (homePagePath) {
            <mat-expansion-panel
              hideToggle="true"
              class="navigation-panel"
              expanded="false"
              (click)="goToHomePage()"
              >
              <mat-expansion-panel-header>
                <mat-panel-title><div>Home</div></mat-panel-title>
              </mat-expansion-panel-header>
            </mat-expansion-panel>
          }
          <ng-template *ngTemplateOutlet="mobile ? mobileExpansion: desktopExpansion"></ng-template>
        </mat-accordion>
      </div>
    </div>
    @if (activePageName) {
      @for (hostedCustomPage of hostedCustomPages; track hostedCustomPage) {
        <app-custom-page
          [nodeID]="hostedCustomPage.customPageId"
          (navigationSections)="updateSections($event)"
          [displayHeader]="false"
          [hosted]="true"
        [ngClass]="
          hostedCustomPage.name === activePageName ? 'active' : 'inactive'
        "
        ></app-custom-page>
      }
    }
  </div>
}

<ng-template #mobileExpansion>
  @for (hostedCustomPage of hostedCustomPages; track hostedCustomPage; let i = $index) {
    <mat-expansion-panel
      hideToggle="true"
      class="navigation-panel"
      [expanded]="i === mobileSidebarExpandIndex"
      >
      <mat-expansion-panel-header (click)="updateActiveCustomPage(hostedCustomPage); mobileSidebarExpandIndex = i">
        <mat-panel-title
          ><div [innerHTML]="hostedCustomPage.title"></div
        ></mat-panel-title>
        @if (hostedCustomPage.navSections && hostedCustomPage.navSections.length) {
          <div class="indicator"
            (click)="$event.stopPropagation(); mobileSidebarExpandIndex = i; indicClick($event)">
            <i class="fas fa-chevron-right"></i>
          </div>
        }
      </mat-expansion-panel-header>
      @if (hostedCustomPage.navSections) {
        <div class="navigation-sections">
          @for (navSection of hostedCustomPage.navSections; track navSection) {
            <div
              (click)="updateActiveCustomPage(hostedCustomPage, navSection.elementId); mobileSidebarExpandIndex = i"
              class="navigation-section"
              >
              {{ navSection.name }}
            </div>
          }
        </div>
      }
    </mat-expansion-panel>
  }

</ng-template>
<ng-template #desktopExpansion>
  @for (hostedCustomPage of hostedCustomPages; track hostedCustomPage) {
    <mat-expansion-panel
      hideToggle="true"
      class="navigation-panel"
      (afterExpand)="updateActiveCustomPage(hostedCustomPage)"
      [expanded]="hostedCustomPage.name == activePageName"
      >
      <mat-expansion-panel-header>
        <mat-panel-title
          ><div [innerHTML]="hostedCustomPage.title"></div
        ></mat-panel-title>
        @if (hostedCustomPage.navSections && hostedCustomPage.navSections.length) {
          <div class="indicator"
            >
            <i class="fas fa-chevron-right"></i>
          </div>
        }
      </mat-expansion-panel-header>
      @if (hostedCustomPage.navSections) {
        <div class="navigation-sections">
          @for (navSection of hostedCustomPage.navSections; track navSection) {
            <div
              (click)="navigateToElement(navSection.elementId)"
              class="navigation-section"
              >
              {{ navSection.name }}
            </div>
          }
        </div>
      }
    </mat-expansion-panel>
  }

</ng-template>
